export default __webpack_public_path__ + "static/media/closed_menu.111c1d61.svg";